import { AuthenticationProvider, AuthenticationProviderOptions } from '@microsoft/microsoft-graph-client';
import { commonAuthManagerInstance } from 'app/helper/authorisation/common/CommonAuthManager';

export class ClientAuthProvider implements AuthenticationProvider{
    getAccessToken(authenticationProviderOptions: AuthenticationProviderOptions | undefined): Promise<string> {
        return commonAuthManagerInstance.getAccessTokenOrShowLoginScreen();
    }
}
